import React from "react";
import { useRoutes } from "react-router-dom";

import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";

function AppRoutes() {
    const routes = useRoutes([
        {
            path: "/pmt",
            element: <HomePage/>,
        },
        {
            path: "/pmt/about",
            element: <AboutPage/>,
        }
    ]);
    return routes;
}

export default AppRoutes;
